// extracted by mini-css-extract-plugin
export default {"rowSelected":"oml10Kw2-i0Nx-G3qqn19g==","table":"_7UcdYZxvGuyeMGkW8NbRMA=="};